import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import routes from '../../../../routes';

import { checkPermission, checkTablePermission } from '../../../../utils/route-auth';
import { formFields, options, userStatusOptions } from './constant';
import { getAdminUserListAction, getTenantAction, addAdminUserAction } from '../../../../actions';
import { Link, withRouter } from "react-router-dom";
import { PERMISSION } from '../../../../constants/permission';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import { getCombinedData, getDateFromUtcToSpecificZone, getTenantTimeZone, getUserListData, isTenantAdvertiser, isTenantDemoAdvertiser } from '../../../../selectors';
import ToastModal from "../../../../components/ToastModal";
import SelectNew from '../../../../components/FormElements/SelectNew';
import { handleFieldError } from '../../../../utils/form-validation';
import moment from 'moment';
import { de } from 'date-fns/locale';
import { message } from 'antd';
import { userList } from "../../../../constants/demo/adminData"
import { infoMessages } from '../../../../constants/demo/constant';

const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class User extends Component {

  constructor(props) {
    super(props);
    this.state = {
      variableList: [],
      tenantId: '',
      optionsList: options,
      confirmationOpen: false,
      confirmationInfo: '',
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      method: "",
      tableRow: {},
      tableAction: {},
      isStatusUpdated: false,
      popOverVisible: false,
      form: {
        status: -1
      },
      touched: {},
      errors: {},
      submited: false
    };
    this.popoverRef = React.createRef();
  }

  componentWillMount() {
    const { tenantId } = this.props;
    const targetTimeZone = getTenantTimeZone(tenantId);
    let optionsList = checkTablePermission({ add: PERMISSION.ADMIN.USERS.ADD, edit: PERMISSION.ADMIN.USERS.EDIT, delete: PERMISSION.ADMIN.USERS.DELETE }, cloneDeep(options));
    optionsList.columns.forEach((dataCol, index) => {
      if (dataCol.name == "modifiedOn") {
        optionsList.columns[index].component = (row) => row.modifiedOn ? moment(getDateFromUtcToSpecificZone({ date: row.modifiedOn, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
      }
    })
    this.setState({ optionsList });

    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.this.props;
      history.push(routes.preSignIn);
    }

    this.updateIsDemoAdvertiser();
    this.initialize();
    this.getVariable();
    this.addEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tenantId !== this.props.tenantId) {
      this.updateIsDemoAdvertiser();
    }
  }

  updateIsDemoAdvertiser = () => {
    const { tenantId } = this.props;
    const isDemoAdvertiser = isTenantDemoAdvertiser(tenantId);
    this.setState({ isDemoAdvertiser });
  };

  async initialize() {
    const { getTenantAction, tenantId, authToken, userId } = this.props;
    await getTenantAction({ tenantId, authToken, userId });
  }

  formartUserList = (userList) => {
    let variableList = userList.responseList.map((item) => {
      item.roleTenantList = getCombinedData(item.roleTenantList)
      return item;
    });
    let list = getUserListData(variableList);
    let users = list.map(user => {
      user.disabledActions = (user.isRecActive == 0 && user.isUserPrimary == false) ? [] : ['ti ti-trash color-beki'];
      return user;
    });

    return users;
  }

  async getVariable() {
    const { getAdminUserListAction, tenantId, authToken, userId } = this.props;
    const { form } = this.state;
    const params = { list: 'all' };
    if (form[formFields.status.key] != -1)
      params['type'] = form[formFields.status.key];

    let respone = await getAdminUserListAction({ tenantId, authToken, userId, params });
    if (respone && respone.responseCode && respone.responseCode.status === "Success" && respone.responseList && respone.responseList.length) {
      let list = this.formartUserList(respone);
      if (this.state.isDemoAdvertiser) {
        this.setState({ variableList: [...list, ...this.formartUserList(userList)] });
      } else {
        this.setState({ variableList: list });
      }
    }
  }

  handleAction = (row, action) => {
    const { match, history } = this.props;
    if (action.type === 'edit') {
      this.handleEdit(row, match, history);
    } else if (action.type === 'remove') {
      if (this.state.isDemoAdvertiser) {
        message.info(infoMessages.userDelete)
        return
      }
      this.setState({ method: 'recActiveStatus' });
      this.handleDelete(row, action);
    } else if (action.key === 'isRecActive') {
      if (this.state.isDemoAdvertiser) {
        message.info(infoMessages.userStatus)
        return
      }
      this.setState({ enableToast: true, confirmationMsg: "Please confirm if you wish to update this record.", toastMsg: "", toastStatus: "", method: 'recActiveStatus', tableRow: row, tableAction: action });

      // this.handleStatus(row, action);
    }
  };

  handleOutsideClick = (event) => {
    if (
      this.popoverRef.current &&
      !this.popoverRef.current.contains(event.target) &&
      this.state.popOverVisible
    ) {
      this.setState({ popOverVisible: false });
    }
  };

  addEventListeners = () => {
    const eventName = 'click';
    document.addEventListener(eventName, this.handleOutsideClick, true);
  };

  removeEventListeners = () => {
    const eventName = 'click';
    document.removeEventListener(eventName, this.handleOutsideClick, true);
  };

  togglePopover = () => {
    this.setState(prevState => ({
      popOverVisible: !prevState.popOverVisible
    }));
  };

  resetFilter = () => {
    const { form } = this.state;
    form[formFields.status.key] = -1;
    this.setState({ form, popOverVisible: false }, () => {
      this.getVariable();
    });
  }

  applyFilter = () => {
    this.setState({ popOverVisible: false }, () => {
      this.getVariable();
    });
  }

  async handleStatus(row, action) {
    const { id } = row
    const { getAdminUserListAction, tenantId, authToken, userId, addAdminUserAction } = this.props;
    let params = { list: id };

    let respone = await getAdminUserListAction({ tenantId, authToken, userId, params });
    if (respone && respone.responseCode && respone.responseCode.status === "Success" && respone.responseList && respone.responseList.length) {
      let payload = respone.responseList.find((a) => a.id == id);
      payload.isRecActive = payload.isRecActive == 1 ? 0 : 1;
      payload.roleTenantList = payload.roleTenantList.map(role => ({ ...role, isRecActive: payload.isRecActive }));
      payload.uID = payload.email;
      let addParams = "auto"
      this.handleStatusUpdate(tenantId, authToken, userId, payload, addParams, addAdminUserAction);
    }
  }

  async handleStatusUpdate(tenantId, authToken, userId, payload, addParams, addAdminUserAction) {
    const { responseCode: { msg = '', status = '' } } = await addAdminUserAction({ tenantId, authToken, userId, payload, addParams }) || {};
    if (status == 'Success') {
      this.setState({ isStatusUpdated: true });
      this.toast(status, msg)
    } else {
      this.setState({ isStatusUpdated: false });
      this.toast(status, msg)
    }
  }

  handleEdit(row, match, history) {
    history.push(`${match.path}/${routes.admin.user.edit}/${row.id}`);
  }

  async handleDelete(row) {
    const { id } = row;
    const { getAdminUserListAction, tenantId, authToken, userId, addAdminUserAction } = this.props;
    let params = { list: id };
    let respone = await getAdminUserListAction({ tenantId, authToken, userId, params });
    if (respone && respone.responseCode && respone.responseCode.status == "Success" && respone.responseList && respone.responseList.length) {
      let payload = respone.responseList.find((a) => a.id == id);
      payload.isActive = 0;
      payload.roleTenantList = payload.roleTenantList.map(role => ({ ...role, isActive: payload.isActive }));
      payload.uID = payload.email;
      let addParams = "auto";
      this.handleStatusUpdate(tenantId, authToken, userId, payload, addParams, addAdminUserAction);
    }
  }

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    this.setState({ confirmationOpen: false });
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    const { method, tableAction, tableRow } = this.state;
    this.setState({ enableToast: false }, () => {
      if (method == "recActiveStatus") {
        this.handleStatus(tableRow, tableAction);
      }
    });
  }

  handleChange = (e) => {
    const { form } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  handleToastStatus = (status) => {
    const { method, isStatusUpdated } = this.state;
    this.setState({ enableToast: status }, () => {
      if (method === "recActiveStatus" && isStatusUpdated) {
        this.getVariable();
      }
    });
    this.setState({ isStatusUpdated: false });
  }

  render() {
    const { confirmationOpen, confirmationInfo, variableList, tenantId, optionsList, enableToast,
      form,
      errors,
      touched,
      submited,
      popOverVisible,
      toastMsg,
      toastStatus,
      confirmationMsg } = this.state;
    // console.log(variableList, "variableList");

    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}

        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + '/' + routes.admin.account.name}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            poc={true}
          />
        }

        <div className="main-panel ion form__style">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row mt-3">
              {/* <Card>

                <Tabs container="admin" />
              </Card> */}
              <Tabs container="admin" />
              <Card >
                <div className='d-flex justify-content-between'>
                  <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={this.togglePopover}>
                    <i className='ti ti-filter ti-sm'></i>
                    Filters
                  </button>

                  {popOverVisible && (
                    <div
                      ref={this.popoverRef}
                      className="popover"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents click event propagation from closing popover
                      }}
                    >

                      <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                        <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                        <button className='close close-popover' onClick={this.togglePopover}>
                          &times;
                        </button>
                      </div>

                      <div className='row flex-column p-3'>
                        <div className='col-md-12'>
                          <SelectNew
                            onChange={this.handleChange}
                            onBlur={this.handleTouch}
                            value={form[formFields.status.key]}
                            setting={formFields[formFields.status.key]}
                            error={errors[formFields.status.key]}
                            submited={false}
                            touched={touched[formFields.status.key]}
                            options={userStatusOptions}
                          />
                        </div>
                        <div className="col-md-12 mt-4 justify-content-end d-flex">
                          <button onClick={() => this.resetFilter()} className="btn btn-outline-primary">Reset</button>
                          <button onClick={() => this.applyFilter()} className="btn btn-primary bg-color-beki ml-3">Apply</button>
                        </div>
                      </div>
                    </div>
                  )}

                  {
                    checkPermission({
                      permissions: [PERMISSION.ADMIN.USERS.ADD]
                    }) &&
                    <Link
                      to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}/${routes.admin.user.add}`}
                      className='text-white text-decoration-none btn btn-primary ml-4'
                      style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
                    >
                      <i className="ti ti-plus ti-sm"></i> Add User
                    </Link>
                  }
                </div>
                <div className='campaign-adj mt-3'>
                  <div className="campaign-list-adj table-responsive">
                    <Table
                      options={optionsList}
                      data={variableList}
                      handelAction={this.handleAction}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    tenantListAll: get(state, 'app.tenantListAll.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
  }), {
  getAdminUserListAction,
  getTenantAction,
  addAdminUserAction,
}
)(User));

User.propTypes = {
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
  getAdminUserListAction: PropTypes.func,
};
